import React, { useState } from "react";

import { Fade } from "react-reveal";

import {
  UpSVG,
  DownSVG,
  ReliabilityAndAuthenticitySVG,
  WorkplaceSafetySVG,
  LackOfDigitalSVG,
} from "../../../../assets/svgs";
import { useWindowDimension } from "../../../../hooks/useWindowDimension";

import "./styles.css";

const image1 = require("../../../../assets/images/ElectionSafety/pollingstation.jpg");
const image2 = require("../../../../assets/images/ElectionSafety/pollingstation2.jpg");
const image3 = require("../../../../assets/images/ElectionSafety/pollingstation3.jpg");

const Problem = () => {
  const windowDimensions = useWindowDimension();
  const [selectedItem, setSelectedItem] = useState(-1);

  const safetyconcerns = [
    "Real-time safety monitoring for election workers.",
    "Allows workers to access help with just one click.",
    "Ensures election workers feel secure and supported throughout the day.",
  ];
  const communicationChallenges = [
    "Instantly report issues like safety concerns, suspicious activity, or technical malfunctions.",
    "Automatically assign reports to the appropriate response teams",
    "Track the resolution of incidents to ensure a smooth election process.",
  ];
  const isolationAndMentalHealth = [
    "Election authorities can review reports in real time.",
    "Time-stamped and geotagged reports offer a transparent reporting system.",
    "Provides accurate records that election officials can rely on.",
  ];

  const Item = ({
    icon,
    title,
    description,
    image,
    imageWidth,
    imageHeight,
    index,
  }) => {
    return (
      <div
        className={`enterprise_problem_item ${
          selectedItem === index || windowDimensions.width < 601
            ? "expanded"
            : ""
        }`}
      >
        <div
          className="panel-header"
          onClick={() =>
            index === selectedItem
              ? setSelectedItem(-1)
              : setSelectedItem(index)
          }
        >
          <div className="panel-header-left">
            {icon}
            <span className="h2-sb text-white">{title}</span>
          </div>
          <div className="panel-header-right">
            {selectedItem === index ? <UpSVG /> : <DownSVG />}
          </div>
        </div>
        <div className="panel-content">
          <ul>
            {description.map((item) => {
              return (
                <li key={item} className="h2-m">
                  {item}
                </li>
              );
            })}
          </ul>
          <img src={image} width={imageWidth} height={imageHeight} alt="Pic" />
        </div>
      </div>
    );
  };
  return (
    <Fade bottom>
      <div id="problem" className="enterprise_problem_container">
        <span className="h2-sb text-white problem_title">
          Here’s what we can do for you
        </span>
        <div className="enterprise_problem_list">
          <Item
            icon={<WorkplaceSafetySVG />}
            title="Safety Monitoring for Election Workers"
            description={safetyconcerns}
            image={image1}
            imageWidth={
              windowDimensions.width > 600
                ? windowDimensions.width * 0.27375
                : "90%"
            }
            imageHeight={
              windowDimensions.width > 600
                ? windowDimensions.width * 0.15
                : "auto"
            }
            index={0}
          />
          <Item
            icon={<LackOfDigitalSVG />}
            title="Real-time Reporting & Incident Management"
            description={communicationChallenges}
            image={image2}
            imageWidth={
              windowDimensions.width > 600
                ? windowDimensions.width * 0.27375
                : "90%"
            }
            imageHeight={
              windowDimensions.width > 600
                ? windowDimensions.width * 0.15
                : "auto"
            }
            index={1}
          />
          <Item
            icon={<ReliabilityAndAuthenticitySVG />}
            title="Enhanced Accountability"
            description={isolationAndMentalHealth}
            image={image3}
            imageWidth={
              windowDimensions.width > 600
                ? windowDimensions.width * 0.27375
                : "90%"
            }
            imageHeight={
              windowDimensions.width > 600
                ? windowDimensions.width * 0.15
                : "auto"
            }
            index={2}
          />
        </div>
      </div>
    </Fade>
  );
};

export default Problem;
